module.exports = __webpack_public_path__ + "static/media/assistance_grey.035eb2fb.svg";